import { useTourStore } from '@/store/useTourStore';
import i18n from '@/i18n';
import Shepherd from 'shepherd.js';
import { TFunction } from 'i18next';

const t: TFunction = i18n.t;

const DashboardTour = new Shepherd.Tour({
  useModalOverlay: true,
  defaultStepOptions: {
    canClickTarget: false
  }
});

DashboardTour.addStep({
  id: 'welcome-step',
  text: () => t('tours.dashboard.welcome'),
  cancelIcon: {
    enabled: true
  },
  buttons: [
    {
      text: () => t('tours.dashboard.startTour'),
      action: DashboardTour.next
    }
  ]
});

DashboardTour.addStep({
  id: 'header-step',
  text: () => t('tours.dashboard.header'),
  attachTo: {
    element: '.tour-header',
    on: 'bottom'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: DashboardTour.next
    }
  ]
});

DashboardTour.addStep({
  id: 'income-step',
  text: () => t('tours.dashboard.income'),
  attachTo: {
    element: '.tour-total-income',
    on: 'bottom'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: DashboardTour.next
    }
  ]
});

DashboardTour.addStep({
  id: 'expense-bar-step',
  text: () => t('tours.dashboard.expenseBar'),
  attachTo: {
    element: '.tour-expense-bar',
    on: 'bottom'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: DashboardTour.next
    }
  ]
});

DashboardTour.addStep({
  id: 'income-widget-step',
  text: () => t('tours.dashboard.recommendations'),
  attachTo: {
    element: '.tour-recommendation-widget',
    on: 'top'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: DashboardTour.next
    }
  ]
});

DashboardTour.addStep({
  id: 'vat-memo-step',
  text: () => t('tours.dashboard.taxCalendar'),
  attachTo: {
    element: '.tour-vat-memo',
    on: 'auto'
  },
  buttons: [
    {
      text: () => t('tours.common.next'),
      action: DashboardTour.next
    }
  ]
});

DashboardTour.addStep({
  id: 'navigation-step',
  text: () => t('tours.dashboard.navigation'),
  attachTo: {
    element: '.tour-nav',
    on: 'auto'
  },
  buttons: [
    {
      text: () => t('tours.dashboard.finishTour'),
      action: DashboardTour.complete
    }
  ]
})

DashboardTour.on('complete', () => {
  useTourStore.setState({ dashboardTourCompleted: true });
});

DashboardTour.on('cancel', () => {
  useTourStore.setState({ dashboardTourCompleted: true });
});

export default DashboardTour
